var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-goods-detail',{staticClass:"pt-goods-detail__withData",attrs:{"goods-detail":_vm.goodsDetail,"id":_vm.id,"goodsUrl":_vm.goodsUrl,"loading":_vm.loading||_vm.urlLoading,"isPublished":_vm.isPublished}})}
var staticRenderFns = []

export { render, staticRenderFns }